import React from "react";
import { Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  return <footer className="bg-background-dark text-foreground-dark py-16">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {}
          <div className="space-y-4">
            <div className="flex gap-4 items-start">
              <img src="https://relaxed-fowl.10web.cloud/wp-content/uploads/2025/09/cropped-Mens-Health-Logo-1.png" alt="IronPeak Men's Health Logo" className="h-42 flex-shrink-0 -mt-3" />
              <p className="text-sm text-muted-foreground-dark leading-relaxed">
                Physician-led men's health and performance care helping men regain energy, strength, and confidence — statewide via telemedicine.
              </p>
            </div>
            <div className="text-sm text-muted-foreground-dark">
              <p>Founded in Prosper, Texas</p>
              <p>(469) 557-5547</p>
              <p className="mt-2 text-xs">Telemedicine available statewide</p>
            </div>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-foreground-dark">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/HomePage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Home
              </Link>
              <Link to="/PricingPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Pricing
              </Link>
              <Link to="/ServicesPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Services
              </Link>
              <Link to="/AboutUsPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                About Us
              </Link>
              <Link to="/ContactPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Contact
              </Link>
              <Link to="https://ironpeakmenshealth.com/learn/" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
                Learn
              </Link>
            </nav>
          </div>

          {}
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-foreground-dark">Connect With Us</h3>
            <div className="flex space-x-4">
                 <Link to="#" className="text-white hover:text-white/70 transition-colors">
                 <Instagram className="size-5" />
                 <span className="sr-only">Instagram</span>
                 </Link>
                 <Link to="https://www.tiktok.com/@ironpeakhealth" className="text-white hover:text-white/70 transition-colors">
                 <svg className="size-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                 <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89
               2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34
               6.34 6.34 0 0 0 6.33-6.34V8.95a8.16 8.16 0 0 0 4.78 1.52V7.03a4.85 4.85 0 0 1-1.01-.34Z" />
                 </svg>
                 <span className="sr-only">TikTok</span>
                 </Link>
              </div>
            <p className="text-sm text-muted-foreground-dark">Mike@ironpeakmenshealth.com</p>
          </div>
        </div>

        <Separator className="my-8 bg-muted-dark" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-muted-foreground-dark">© 2026 IronPeak Men's Health. All rights reserved.</p>
          <div className="flex space-x-6">
            <Link to="/PrivacyPolicyPage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
              Privacy Policy
            </Link>
            <Link to="/TermsOfServicePage" className="text-sm text-muted-foreground-dark hover:text-foreground-dark transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}